import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from './Grid';
import Column from './Column';
import { getOtherProps, widthClass, GRID_WIDTHS } from '../util';

var FooterSection = /*#__PURE__*/function (_React$Component) {
  _inherits(FooterSection, _React$Component);

  function FooterSection() {
    _classCallCheck(this, FooterSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(FooterSection).apply(this, arguments));
  }

  _createClass(FooterSection, [{
    key: "renderChildren",
    value: function renderChildren() {
      return React.createElement(Grid, null, React.createElement("nav", {
        className: "wds-c-footer__nav",
        "aria-label": this.props.ariaLabel
      }, React.Children.map(this.props.children, function (child) {
        return child;
      }), this.renderLanguageDropdown()));
    }
    /**
     * Renders the social contact links part of Large Footer
     */

  }, {
    key: "renderSecondarySectionForLarge",
    value: function renderSecondarySectionForLarge() {
      return React.createElement(Grid, null, React.createElement(Column, {
        className: "wds-c-footer-logo",
        width: "1/2"
      }, React.createElement("img", {
        className: "wds-c-footer-logo-img",
        src: this.props.logo,
        alt: ""
      }), React.createElement("h3", {
        className: "wds-c-footer__logo-heading"
      }, this.props.nameOfAgency)), React.createElement(Column, {
        className: "wds-c-footer__contact-info",
        width: "1/2"
      }, React.createElement("h3", {
        className: "wds-c-footer__contact-heading"
      }, this.props.agencyContactName), React.createElement("address", null, React.createElement("p", null, React.createElement("a", {
        className: "wds-c-footer-contact-number",
        href: "tel:".concat(this.props.agencyContactNumber)
      }, this.props.contactInfo)), React.createElement("p", null, React.createElement("a", {
        className: "wds-c-footer-contact-email",
        href: "mailto:".concat(this.props.mailTo)
      }, this.props.mailTo))), React.createElement("p", {
        className: "wds-u-type--small"
      }, React.createElement("a", {
        href: this.props.userTermsLink
      }, this.props.userTermsText)), React.createElement("p", null, this.props.copyrightsMsg)));
    }
    /**
     * Renders the Topic Section Link for Large Footer
     */

  }, {
    key: "renderPrimarySectionForLarge",
    value: function renderPrimarySectionForLarge() {
      var navClassName = classNames('wds-c-footer__nav', _defineProperty({}, "".concat(widthClass(this.props.navSectionWidth)), this.props.navSectionWidth));
      return React.createElement(Grid, null, React.createElement("nav", {
        className: navClassName,
        "aria-label": this.props.ariaLabel
      }, React.Children.map(this.props.children, function (child) {
        return child;
      })), this.renderLanguageDropdown());
    }
    /**
     * Renders the Language Dropdown selection
     */

  }, {
    key: "renderLanguageDropdown",
    value: function renderLanguageDropdown() {
      return this.props.languageDropdown ? React.createElement("ul", {
        className: classNames('wds-c-unstyled-list', _defineProperty({}, "".concat(widthClass(this.props.languageDropdownWidth)), this.props.languageDropdownWidth))
      }, React.createElement("li", {
        className: "wds-c-footer-section__content"
      }, this.props.languageDropdown)) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var otherProps = getOtherProps(FooterSection.propTypes, this.props);
      return React.createElement("div", _extends({}, otherProps, {
        className: classNames('wds-c-footer-section', "wds-c-footer-section--".concat(this.props.category), this.props.className)
      }), !this.props.largeFooter && this.renderChildren(), this.props.largeFooter && this.props.category === 'primary' && this.renderPrimarySectionForLarge(), this.props.largeFooter && this.props.category === 'secondary' && this.renderSecondarySectionForLarge());
    }
  }]);

  return FooterSection;
}(React.Component);

FooterSection.propTypes = {
  /** additional style class(es) */
  className: PropTypes.string,

  /**  Contact info for large footer */
  contactInfo: PropTypes.string,

  /**  The email address info for large footer */
  mailTo: PropTypes.string,

  /**  Name of the govt agency */
  nameOfAgency: PropTypes.string,

  /**  path to the image of the agency's logo */
  logo: PropTypes.string,

  /**  Agency contact Personnel Name */
  agencyContactName: PropTypes.string,

  /**  Agency contact number */
  agencyContactNumber: PropTypes.string,

  /**  Links in LinkGroup */
  children: PropTypes.node,

  /**  category of the FooterSection */
  category: PropTypes.oneOf(['primary', 'secondary']),

  /**  width specifier for navigation links in footer of type large */
  navSectionWidth: PropTypes.oneOf(GRID_WIDTHS),

  /**  Language Dropdown List */
  languageDropdown: PropTypes.element,

  /**  Indicates if footer type is large or not */
  largeFooter: PropTypes.bool,

  /**  Copyrights text message */
  copyrightsMsg: PropTypes.string,

  /**  link to user terms and conditions */
  userTermsLink: PropTypes.string,

  /**  User terms and conditions Text display */
  userTermsText: PropTypes.string,

  /**  Width of the Language Dropdown field in the footer */
  languageDropdownWidth: PropTypes.oneOf(GRID_WIDTHS),

  /**  aria label for navigation */
  ariaLabel: PropTypes.string
};
FooterSection.defaultProps = {
  className: undefined,
  contactInfo: undefined,
  copyrightsMsg: undefined,
  userTermsLink: '',
  userTermsText: undefined,
  mailTo: undefined,
  nameOfAgency: undefined,
  logo: undefined,
  agencyContactName: undefined,
  agencyContactNumber: undefined,
  children: undefined,
  category: 'primary',
  navSectionWidth: undefined,
  languageDropdown: undefined,
  languageDropdownWidth: undefined,
  largeFooter: false,
  ariaLabel: undefined
};
export default FooterSection;